import React, { useState, useEffect, createRef } from 'react';
import { useDispatch, useSelector } from 'react-redux'

import { selectFilteredStations, mapBoundsChanged } from '../store/stationsSlice'

import { RenderAfterNavermapsLoaded, NaverMap, Marker } from 'react-naver-maps'
import { useTranslation } from 'react-i18next';
// import { MarkerIcons } from 'navermaps'


const NAVER_MAP_CLIENT_ID = 'eqru4ypgij'
// const NAVER_MAP_CENTER = { lat: 36.2580859, lng: 127.5046376 }
const NAVER_MAP_INITIAL_ZOOM_LEVEL = 7;
const NAVER_MAP_INITIAL_CENTER = { lat: 36.2580, lng: 127.5046 }

const NAVER_MAP_DEFAULT_MARKER_COODS = [11,0,9,0,6,1,4,2,2,4,0,8,0,12,1,14,2,16,5,19,5,20,6,23,8,26,9,30,9,34,13,34,13,30,14,26,16,23,17,20,17,19,20,16,21,14,22,12,22,12,22,8,20,4,18,2,16,1,13,0]

const _markerMap = {}


export const Map = ({ clickedStationFromTable }) => {
  const { t } = useTranslation();
  let naverMapRef = null
  // console.log('Map() is called', naverMapRef)

  // const [mapZoomLevel, setMapZoomLevel] = useState(NAVER_MAP_INITIAL_ZOOM_LEVEL)
  const [selectedStationCode, setSelectedStationCode] = useState('')
  
  const filteredStations = useSelector(selectFilteredStations)
  // console.log('Map:: filteredStations =', filteredStations)
  const handleMarkerClick = (stationCode, anchor) => {
    if (naverMapRef) {
      if (!naverMapRef.__infoWindow) {
        naverMapRef.__infoWindow = new window.naver.maps.InfoWindow({
          backgroundColor: 'transparent',
          borderWidth: 0,
        })
      }

      if(selectedStationCode !== stationCode) {
        const selectedStation = filteredStations.find((station) => station.code === stationCode)
        // const site_class = selectedStation.site_class ? `${selectedStation.site_class.vs30}, ${selectedStation.site_class.h_and_vs_soil}` : ''
        const infoWindowContent = [
          '<div class="map_info_popup">',
            '<div class="alert">',
              `<div class="map_info_popup_title">${selectedStation.name} (${selectedStation.code})<span style="position: absolute; right: 12px;" onclick="window.dispatchEvent(new CustomEvent('closeInfoWindow'))">&#10005;</span></div>`,
              '<div class="map_info_popup_text">',
                `<span>${t('page.stations.installationType.title')}: <span>${t('page.stations.installationType.' + selectedStation.stationType)}</span></span><br/>`,
                `<span>${t('page.stations.sensorTypes')}: <span>${selectedStation.sensors.map(s => t('sensorType.' + s)).join(', ')}</span></span><br/>`,
                // `<span>지반분류: <span>${site_class}</span></span><br/>`,
              '</div>',
              // '<div class="right-align"><a class="modal-trigger" onclick="console.log(this)">상세정보</a></div>',
              `<div class="right-align"><a class="modal-trigger" onclick="window.dispatchEvent(new CustomEvent('showStationDetails', { detail: '${selectedStation.code}' }))">상세정보</a></div>`,
            '</div>',
          '</div>',
        ].join('');
        naverMapRef.__infoWindow.setContent(infoWindowContent)
        naverMapRef.__infoWindow.open(naverMapRef.map, anchor)
        
        setSelectedStationCode(stationCode)
      } else {
        naverMapRef.__infoWindow.close()
        setSelectedStationCode('')
      }
    }
  }

  const { naver } = window;
  const markers = filteredStations.map((station) => (
    <Marker
      key={station.code}
      position={{ lat: station.latitude, lng: station.longitude }}
      title={station.code} onClick={(e) => handleMarkerClick(station.code, e.overlay)}
      icon={(station.end_date
        ? {url: 'https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/icons/marker_station_closed.png'}
        : {url: 'https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/icons/marker_station_active.png'})}
    />
  ))

  const closeInfoWindow = (event) => {
    if (naverMapRef && naverMapRef.__infoWindow) {
      naverMapRef.__infoWindow.close()
      setSelectedStationCode('')
      event.stopPropagation()
    }
  }

  useEffect(() => {
    if (naverMapRef && naverMapRef.__infoWindow) {
      window.addEventListener('closeInfoWindow', closeInfoWindow)
    }
  })

  const dispatch = useDispatch()
  const handleMapBoundsChanged = (bounds) => {
    // console.log(bounds)
    // const east = bounds.east()
    // const west = bounds.west()
    // const north = bounds.north()
    // const south = bounds.south()
    // console.log(east, west, north, south)
    dispatch(mapBoundsChanged({
      north: bounds._ne._lat,
      east: bounds._ne._lng,
      west: bounds._sw._lng,
      south: bounds._sw._lat,
    }))
  }

  return(
    <div id="map" style={{width:"100%", height:"800px", overflow: "hidden"}}>
      <RenderAfterNavermapsLoaded 
        govClientId={NAVER_MAP_CLIENT_ID}
        error={<p>Maps Load Error</p>}
        loading={<p>Maps Loading...</p>}
      >
        <NaverMap
          naverRef={ref => { naverMapRef = ref }} 
          style={{width:"100%", height:"100%", overflow: "hidden"}}
          zoom={NAVER_MAP_INITIAL_ZOOM_LEVEL}
          center={NAVER_MAP_INITIAL_CENTER}
          // onCenterChanged={center => console.log(center)}
          // onZoomChanged={setMapZoomLevel}
          onBoundsChanged={handleMapBoundsChanged}
        >
          {markers}
        </NaverMap>
      </RenderAfterNavermapsLoaded>
    </div>
  );
}